export const HeroComponent = () => {
  return (
    <div className="flex sm:flex-col-reverse">
      <div className="left w-2/3 sm:w-full flex flex-col justify-center">
        <div className="heading text-s-48 font-bold sm:text-center sm:text-s-36">
          Expert assisted ITR filing
        </div>
        <div className="sub-heading text-s-20 font-medium text-gray-400 pt-2 sm:text-s-14 sm:text-black sm:px-7 sm:text-center">
          A premium, end-to-end tax journey—personalized by top tax experts.
        </div>
        <ul className="flex gap-3 pt-6 sm:grid sm:grid-cols-2 ">
          <li className="w-1/4 sm:w-3/4">
            <img
              src="https://assets.clear.in/cleartax/images/1746018174_frame18142215243.svg"
              alt=""
            />

            <div className="font-semibold text-base text-gray-600 ">
              Live Tax filing experience
            </div>
          </li>
          <li className="w-1/4 sm:w-3/4">
            <img src="https://assets.clear.in/cleartax/images/1746018496_frame1814221524.svg" />

            <div className="font-semibold text-base text-gray-600 ">
              Guaranteed filing in 24 hours
            </div>
          </li>
          <li className="w-1/4 sm:w-3/4">
            <img
              src="https://assets.clear.in/cleartax/images/1746018253_frame18142215242.svg"
              alt=""
            />

            <div className="font-semibold text-base text-gray-600">
              Hand-pick from India’s Top Tax experts
            </div>
          </li>
          <li className="w-1/4 sm:w-3/4">
            <img
              src="https://assets.clear.in/cleartax/images/1746018212_frame18142215241.svg"
              alt=""
            />
            <div className="font-semibold text-base text-gray-600 ">
              Tax done with 100% accuracy
            </div>
          </li>
        </ul>
      </div>
      <div className="w-1/3 right sm:w-full sm:h-64 sm:hidden">
        <video
          src="https://assets.clear.in/cleartax/images/1748255819_expert.mp4"
          autoPlay
          loop
          muted
        ></video>
      </div>
    </div>
  );
};
